<!--
 * @Descripttion: ''
 * @Author: lilong(lilong@hztianque.com)
 * @Date: 2020-07-20 08:45:59
 * @LastEditTime: 2021-05-25 08:54:05
-->
<template>
  <div class="reportManagement">
    <div class="project-content">
      <div class="project-second-filter">
        <middle-filter @query="query" @reset="reset" @exportData="exportDataList"></middle-filter>
      </div>
      <div class="project-table-tab">
        <loading v-if="showSpin"></loading>
        <s-table
          class="list-table"
          :list="listData"
          :pageSize="pageSizeLeft"
          :total="listLeftTotal"
          :column="columnsLeft"
          :isLoading="false"
          :filterVisible="false"
          :currentPage="currentPageLeft"
          :showPageSize="true"
          @on-page-change="filterListLeft"
          @on-page-size-change="pageSize"></s-table>
        <i-filed-filter class="fieldStyle" :fields="items" @changeColumns="handleInput" />
      </div>
    </div>
    <hotel-mask
      :show="show"
      :hotelList.sync="hotelList"
      :formValidates.sync="formValidate"
      @showModel="closeModal"></hotel-mask>
  </div>
</template>

<script>
import middleFilter from './components/middle-filter'
import hotelMask from './components/hotel-mask'
import { mapActions } from 'vuex'
import axios from 'axios'
export default {
  components: {
    middleFilter,
    hotelMask,
  },
  data() {
    return {
      cityLists: [],
      cityList: [],
      showSpin: false,
      currentPageLeft: 1,
      pageSizeLeft: 10,
      listLeftTotal: 1,
      selectData: [], //选中的项
      columnsLeft: [],
      columnList: [
        // {
        //   type: 'selection',
        //   width: 60,
        //   align: 'center',
        //   fixedItem: true,
        //   checked: true,
        // },
        {
          title: '参会id',
          key: 'id',
          align: 'center',
          checked: true,
          tooltip: true,
        },
        {
          title: '单位类型',
          key: 'unitTypeName',
          align: 'center',
          checked: true,
        },
        {
          title: '单位名称',
          key: 'unitName',
          align: 'center',
          checked: true,
          tooltip: true,
        },
        {
          title: '姓名',
          key: 'name',
          align: 'center',
          checked: true,
          tooltip: true,
        },
        {
          title: '性别',
          key: 'gender',
          align: 'center',
          checked: true,
          sortable: true,
        },
        {
          title: '职务',
          key: 'post',
          align: 'center',
          checked: true,
          tooltip: true,
        },
        {
          title: '电话',
          key: 'telphone',
          align: 'center',
          checked: true,
          tooltip: true,
        },
        {
          title: '邮箱',
          key: 'email',
          align: 'center',
          checked: true,
          tooltip: true,
        },
        {
          title: '航班车次',
          key: 'fightNumber',
          align: 'center',
          checked: true,
          tooltip: true,
        },
        {
          title: '入驻酒店',
          key: 'hotelName',
          align: 'center',
          checked: true,
          tooltip: true,
        },
        {
          title: '入驻时间',
          key: 'checkTime',
          align: 'center',
          checked: true,
          render: (h, { row }) => {
            return h('div',
              row.checkTime ? this.$moment(row.checkTime).format('YYYY-MM-DD') : '')
          },
        },
        {
          title: '离店时间',
          key: 'departureTime',
          align: 'center',
          checked: true,
          render: (h, { row }) => {
            return h('div',
              row.departureTime ? this.$moment(row.departureTime).format('YYYY-MM-DD') : '')
          },
        },
        {
          key: 'operate',
          title: '操作',
          align: 'center',
          checked: 'true',
          render: (h, { row }) => {
            return h(
              'div',
              {
                style: {
                  display: 'flex',
                  justifyContent: 'space-around',
                },
              },
              [
                h(
                  'a',
                  {
                    on: {
                      click: () => {
                        this.editorById(row)
                      },
                    },
                  },
                  '修改酒店',
                ),
              ],
            )
          },
        },
      ], //列表项
      listData: [], //列表数据
      items: [],
      downLoadFormdata: {},
      testR: true,
      show: false,
      formValidate: {},
      hotelList: [],
    }
  },
  watch: {
    // 'downLoadFormdata.unitType'(v) {
    //   console.log(v)
    //   if (v && v === 2) {
    //     this.testR = false
    //   } else {
    //     this.testR = true
    //   }
    // },
  },
  created() {
    this.columnsLeft = this.columnList.filter(element => element.checked)
    this.items = this.columnList
    const formValue = {
      id: '', //参会ID
      name: '', //姓名
      telphone: '', //电话
      unitType: '', //单位时间
      hotelName: '', //入驻酒店
      startTime: this.$moment(new Date()).format('YYYY-MM-DD'), //时间开始
      endTime: this.$moment(new Date()).format('YYYY-MM-DD'), //时间结束
      departureTime: this.$moment(new Date()).format('YYYY-MM-DD'),
    }
    this.downLoadFormdata = formValue
    this.queryDataList(formValue)
  },
  methods: {
    async exportDataList() {
      if (this.listData.length <= 0) {
        this.$Message.info('暂无数据导出')
        return
      }
      delete this.downLoadFormdata.pageNo
      delete this.downLoadFormdata.pageSize
      axios({
        method: 'get',
        url: `/api/signUp/exportSignUps?id=${this.downLoadFormdata.id}&hotelName=${this.downLoadFormdata.hotelName}&name=${this.downLoadFormdata.name}&telphone=${this.downLoadFormdata.telphone}&unitType=${this.downLoadFormdata.unitType}&startTime=${this.downLoadFormdata.startTime}&endTime=${this.downLoadFormdata.endTime}&departureTime=${this.downLoadFormdata.departureTime}`,
        responseType: 'blob',
        // data: JSON.stringify(this.downLoadFormdata),
        headers: {
          'Content-Type': 'application/json',
        },
      }).then((res) => {
        const link = document.createElement('a')
        const blob = new Blob([res.data], { type: 'application/vnd.ms-excel' })
        const fileName = '参会人员.xls' // 文件名字
        link.style.display = 'none'
        link.href = URL.createObjectURL(blob)
        // link.download = res.headers['content-disposition'] //下载后文件名
        link.download = fileName //下载的文件名
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }).catch(error => {
        console.log(error)
      })
    },
    // 删除
    async getDeleteById(id) {
      const res = await this.deleteByIds({ signUpIds: id })
      if (res.code === '0' && res.flag === '0') {
        this.$Message.success('删除成功')
        this.queryDataList(this.downLoadFormdata)
      }
    },
    //搜索
    async queryDataList(formValue) {
      formValue.startTime = formValue.startTime ? this.$moment(formValue.startTime).format('YYYY-MM-DD') : ''
      formValue.endTime = formValue.endTime ? this.$moment(formValue.endTime).format('YYYY-MM-DD') : ''
      formValue.departureTime = formValue.departureTime ? this.$moment(formValue.departureTime).format('YYYY-MM-DD') : ''
      const dataObj = {
        pageNo: this.currentPageLeft,
        pageSize: this.pageSizeLeft,
        ...formValue,
      }
      this.downLoadFormdata = dataObj
      const { dataResult } = await this.getQueryData(dataObj)
      this.listData = dataResult.rows
      this.listLeftTotal = dataResult.total
      this.currentPageLeft = dataResult.page
    },
    query(data) {
      const dataList = {
        ...data,
        pageNo: 1,
        pageSize: 10,
      }
      this.queryDataList(dataList)
    },
    //重置
    reset(data) {
      const dataListValue = {
        ...data,
        pageNo: 1,
        pageSize: 10,
      }
      this.queryDataList(dataListValue)
    },
    // 列表自定义
    handleInput(data) {
      this.columnsLeft = data.filter(element => element.checked)
    },
    pageSize(size = 10) {
      this.pageSizeLeft = size
      this.downLoadFormdata = {
        ...this.downLoadFormdata,
        pageSize: size,
      }
      this.queryDataList(this.downLoadFormdata)
    },
    filterListLeft(page = 1) {
      this.currentPageLeft = page
      this.downLoadFormdata = {
        ...this.downLoadFormdata,
        pageNo: page,
      }
      this.queryDataList(this.downLoadFormdata)
    },
    // 修改酒店
    async editorById(data) {
      this.formValidate = data
      let obj = {
        hotelId: 0,
      }
      if (data.hotelName && data.hotelId) {
        obj = {
          hotelId: data.hotelId,
        }
      }
      this.show = true
      const { dataResult } = await this.hotelDetails(obj)
      this.hotelList = dataResult
    },
    // 关闭
    closeModal(val) {
      this.show = val
      this.queryDataList(this.downLoadFormdata)
    },
    ...mapActions({
      getQueryData: 'jurisprudenceDaily/reportManagement/getQueryData',
      exportDataDeal: 'jurisprudenceDaily/reportManagement/exportDataDeal',
      deleteByIds: 'jurisprudenceDaily/reportManagement/deleteByIds',
      hotelDetails: 'jurisprudenceDaily/reportManagement/hotelDetails',
    }),
  },
}
</script>

<style lang='scss' scoped>
.reportManagement {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  // padding:20px;
  .project-content {
    padding: 20px;
    height: calc(100% - 0px);
  }
  .project-top-filter {
    width: 100%;
    border-bottom: 1px solid #e9e9e9;
    padding: 0 20px;
    .select-box {
      margin-right: 20px;
    }
    /deep/.ivu-row {
      display: flex;
      align-items: center;
      height: 70px;
    }
  }
  .project-second-filter {
    // padding: 20px;
    display: flex;
    justify-content: space-between;
    .filter {
      display: flex;
      > .filter-box {
        margin-right: 20px;
        button {
          margin-right: 10px;
        }
        label {
          width: 70px;
          height: 20px;
          font-size: 14px;
          font-family: PingFangSC, PingFangSC-Regular;
          font-weight: 400;
          text-align: left;
          color: #666666;
          line-height: 20px;
        }
        .centerLine {
          margin: 0 10px;
        }
      }
    }
  }
  .project-table-tab {
    margin-top: 10px;
    height: calc(100% - 80px);
    position: relative;
  }
}
</style>